import { useState } from "react";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import {
  FormWrapper,
  Form,
  FormGroup
} from "../../../../components/CustomForm/FormStyles";
import Colors from "../../../../themes/Colors";
import useEmpresa from "../../../../hooks/useEmpresa";
import { isNumber } from "../../../../utils/NumberUtil";
import PropTypes from "prop-types";
import { cleanNumber } from "../../../../utils/NumberUtil";

const PrecertificacionBuscarAfiliado = (props) => {
  const { cargando, mostrarAlerta, buscar } = props;
  const empresa = useEmpresa();
  const [numeroPlastico, setNumeroPlastico] = useState();

  const onFormSubmit = (e) => {
    e.preventDefault();

    if (!numeroPlastico || !isNumber(numeroPlastico) || numeroPlastico === 0) {
      mostrarAlerta(
        "No. de afiliado/carnet es requerido y debe ser un número válido"
      );
      return;
    }
    buscar(numeroPlastico);
  };

  const handleNumeroPlasticoChange = (value) => {
    setNumeroPlastico(cleanNumber(value));
  };

  return (
    <Section>
      <FormWrapper borderColor={Colors.transparent}>
        <Form justifyContent={"space-between"} onSubmit={onFormSubmit}>
          <FormGroup width={"48%"}>
            <CustomInput
              font={empresa?.LETRA_PRINCIPAL}
              type={"text"}
              placeholder={"No. de afiliado/carnet"}
              label={"Consultar Afiliado"}
              isLabelWithContainer={true}
              width={"95%"}
              labelWidth={"100%"}
              value={numeroPlastico}
              onChange={handleNumeroPlasticoChange}
              maxLength={14}
            />
          </FormGroup>

          <FormGroup>
            <CustomButton
              label={"Buscar"}
              width={"200px"}
              isLoading={cargando}
              type={"submit"}
            />
          </FormGroup>
        </Form>
      </FormWrapper>
    </Section>
  );
};

PrecertificacionBuscarAfiliado.propTypes = {
  cargando: PropTypes.bool,
  mostrarAlerta: PropTypes.func.isRequired,
  buscar: PropTypes.func.isRequired
};

export default PrecertificacionBuscarAfiliado;
